import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2c70ddaa&scoped=true"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=2c70ddaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70ddaa",
  null
  
)

export default component.exports